import 'lazysizes'
import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import VueWaypoint from 'vue-waypoint'
import VueScrollTo from 'vue-scrollto'
import VueClipboard from 'vue-clipboard2'
import VueMatomo from 'vue-matomo'
import { mapState, mapGetters } from 'vuex'

import '@/css/tailwind.styl'

if (!window.HTMLPictureElement || !('sizes' in document.createElement('img'))) {
  console.log('will this load')
  require('lazysizes/plugins/respimg/ls.respimg')
}
if (!('object-fit' in document.createElement('a').style)) {
  require('lazysizes/plugins/object-fit/ls.object-fit')
}

const requireComponent = require.context(
  './components',
  false,
  /Base[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)

  const componentName = upperFirst(
    camelCase(
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  )

  Vue.component(
    componentName,
    componentConfig.default || componentConfig
  )
})

Vue.config.productionTip = false

// available in every component
Vue.mixin({
  computed: {
    ...mapState(['locale']),
    ...mapGetters([
      'localeLink',
      'localeList',
      'localeItem',
      '$t'
    ])
  }
})

Vue.use(VueClipboard)
Vue.use(VueWaypoint)
Vue.use(VueScrollTo)

// Tracking
Vue.use(VueMatomo, {
  // Configure your matomo server and site by providing
  host: 'https://stats.timesmuseum.org',
  siteId: 1,
  // Changes the default .js and .php endpoint's filename
  // Default: 'matomo'
  trackerFileName: 'matomo',
  // Overrides the autogenerated tracker endpoint entirely
  // Default: undefined
  trackerUrl: 'https://stats.timesmuseum.org/piwik.php',

  // Overrides the autogenerated tracker script path entirely
  // Default: undefined
  // trackerScriptUrl: 'https://example.com/whatever/script/path/you/have',
  trackerScriptUrl: 'https://stats.timesmuseum.org/piwik.js',

  // Enables automatically registering pageviews on the router
  router: router,

  // Enables link tracking on regular links. Note that this won't
  // work for routing links (ie. internal Vue router links)
  // Default: true
  enableLinkTracking: true,

  // Require consent before sending tracking information to matomo
  // Default: false
  requireConsent: false,

  // Whether to track the initial page view
  // Default: true
  trackInitialView: true,

  // Run Matomo without cookies
  // Default: false
  disableCookies: false,

  // Enable the heartbeat timer (https://developer.matomo.org/guides/tracking-javascript-guide#accurately-measure-the-time-spent-on-each-page)
  // Default: false
  enableHeartBeatTimer: false,

  // Set the heartbeat timer interval
  // Default: 15
  heartBeatTimerInterval: 15,

  // Whether or not to log debug information
  // Default: false
  debug: false,

  // UserID passed to Matomo (see https://developer.matomo.org/guides/tracking-javascript-guide#user-id)
  // Default: undefined
  userId: undefined,

  // Share the tracking cookie across subdomains (see https://developer.matomo.org/guides/tracking-javascript-guide#measuring-domains-andor-sub-domains)
  // Default: undefined, example '*.example.com'
  cookieDomain: undefined,

  // Tell Matomo the website domain so that clicks on these domains are not tracked as 'Outlinks'
  // Default: undefined, example: '*.example.com'
  domains: undefined,

  // A list of pre-initialization actions that run before matomo is loaded
  // Default: []
  // Example: [
  //   ['API_method_name', parameter_list],
  //   ['setCustomVariable','1','VisitorType','Member'],
  //   ['appendToTrackingUrl', 'new_visit=1'],
  //   etc.
  // ]
  preInitActions: []
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
